import script from "./utility-switching-agent-nav-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./utility-switching-agent-nav-menu.vue?vue&type=script&setup=true&lang=ts"

import "./utility-switching-agent-nav-menu.vue?vue&type=style&index=0&id=9ae0434e&lang=scss"

const __exports__ = script;

export default __exports__